import { createFileRoute } from "@tanstack/react-router";
import { ensureEnterpriseCustomerContext } from "../lib/enterpriseCustomerContext";
import { enterpriseOverviewQueryOptions } from "../queries/useGetEnterpriseOverview";
import { itemsOfConcernQueryOptions } from "../queries/useGetItemsOfConcern";
import { recentWinsQueryOptions } from "../queries/useGetRecentWins";
import { EnterpriseSandboxPage } from "../screens/EnterpriseSandboxPage";

export const Route = createFileRoute("/_app/sandbox")({
  loaderDeps: ({ search }) => ({
    externalCustomerId: search.externalCustomerId,
  }),
  loader: async ({ context, deps }) => {
    if (!deps.externalCustomerId) {
      return;
    }

    const customer = await ensureEnterpriseCustomerContext(
      context.queryClient,
      deps.externalCustomerId,
    );

    await Promise.all([
      context.queryClient.ensureQueryData(
        enterpriseOverviewQueryOptions(customer.customerId),
      ),
      context.queryClient.ensureQueryData(
        recentWinsQueryOptions(customer.customerId),
      ),
      context.queryClient.ensureQueryData(
        itemsOfConcernQueryOptions(customer.customerId),
      ),
    ]);
  },
  component: () => <EnterpriseSandboxPage />,
});
